import React, { useEffect } from 'react'
import styled from '@emotion/styled'
import { Button } from '@labsavvyapp/components'
import { useOrdersetSettingsPageBusinessLogic } from '../../../../logic/context'
import { OrdersetListFilters } from './components'

const OrdersetSettingsHeaderControlsLayout = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  align-content: center;
  justify-content: center;
  gap: 10px;
`

export const EditOrdersetHeaderControls = () => {
  const pageLogic = useOrdersetSettingsPageBusinessLogic()
  const userSelectedOrdersetData = pageLogic?.userSelectedOrdersetData ?? null
  const payload = pageLogic?.editOrdersetForm.values ?? null
  const existingOrdersets = pageLogic?.ordersetList ?? []

  const isSameNameAsBefore = userSelectedOrdersetData?.name?.toLowerCase() === payload?.name?.toLowerCase()
  const isNameExistingInList = isSameNameAsBefore
    ? false
    : existingOrdersets.some(
        (orderset) =>
          orderset?.name?.toLowerCase() === payload?.name?.toLowerCase() && payload?.name?.toLowerCase() !== userSelectedOrdersetData?.name,
      )
  const isOrdersetPrivate = userSelectedOrdersetData?.is_private ?? false

  useEffect(() => {
    if (isNameExistingInList) {
      pageLogic?.editOrdersetForm.setFieldError('name', 'This orderset name already exists. Please choose another name or click Cancel.')
    }
  }, [isNameExistingInList])

  const handleSaveOrdersetClick = () => {
    pageLogic?.updateOrderset()
  }

  const handleCancelClick = () => {
    pageLogic?.editOrdersetForm?.reset()
    pageLogic?.goToOrdersetListPage()
  }

  return (
    <OrdersetSettingsHeaderControlsLayout>
      <OrdersetListFilters />

      <Button radius="xl" size="md" uppercase variant="subtle" onClick={handleCancelClick}>
        Cancel
      </Button>
      {isOrdersetPrivate && (
        <>
          <Button radius="xl" size="md" uppercase variant="filled" onClick={handleSaveOrdersetClick}>
            Update Orderset
          </Button>
        </>
      )}
    </OrdersetSettingsHeaderControlsLayout>
  )
}
